import transformToCamelCase from '../toCamelCaseTransformer';
import conversionRate from '@/utils/conversionRate';
import isPlainObject from '../../utility/isPlainObject';

/**
 * Transforms single bid object
 * @param {object} bid
 * @returns {object} Transformed bid with camelcase properties and conversionRate property
 */
export default function singleBidTransformer(bid) {
  if (!isPlainObject(bid)) {
    return {};
  }
  return {
    ...transformToCamelCase(bid),
    conversionRate: conversionRate(bid.install_count, bid.impression_count),
  };
}
